/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import pearBlueUrl from '../../../assets/gems/pear_blue.svg?inline';
export function PearBlue({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: pearBlueUrl,
        alt: "PearBlueImage"
    });
}
